import { render } from "./EditOrderRequest.vue?vue&type=template&id=17685e3e"
import script from "./EditOrderRequest.vue?vue&type=script&lang=js"
export * from "./EditOrderRequest.vue?vue&type=script&lang=js"
script.render = render

export default script